export const AUTH_STORAGE_KEY = 'wiggin_office_auth'

export function getStoredSessionToken(): string {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY)
    if (!raw) return ''

    const parsed = JSON.parse(raw) as {
      user?: { sessionToken?: string }
    }

    return parsed.user?.sessionToken || ''
  } catch {
    return ''
  }
}
